module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/070-tuvalu-1-561f29dd5ba2f316a48fa9005a97595f.svg";